var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeploy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 43,
    viewBox: "0 0 37 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66578 22.9998C4.66578 12.824 10.4711 4.12721 18.6658 0.635986C26.8604 4.12721 32.6658 12.824 32.6658 22.9998C32.6658 24.6458 32.5138 26.2528 32.2246 27.8054L36.1054 31.4706C36.4356 31.7826 36.5142 32.2778 36.2966 32.6766L31.3058 41.8266C31.0412 42.3114 30.4338 42.4902 29.949 42.2256C29.8652 42.18 29.7882 42.1224 29.7208 42.0548L25.2516 37.5856C24.8764 37.2106 24.3678 36.9998 23.8374 36.9998H13.4942C12.9638 36.9998 12.4551 37.2106 12.08 37.5856L7.6108 42.0548C7.22028 42.4454 6.58712 42.4454 6.19658 42.0548C6.12906 41.9874 6.07154 41.9104 6.0258 41.8266L1.03486 32.6766C0.817362 32.2778 0.895903 31.7826 1.22612 31.4706L5.1069 27.8054C4.81764 26.2528 4.66578 24.6458 4.66578 22.9998ZM7.61746 36.3914L9.25156 34.7572C10.3768 33.632 11.9029 32.9998 13.4942 32.9998H23.8374C25.4286 32.9998 26.9548 33.632 28.08 34.7572L29.714 36.3914L31.6778 32.791L29.4782 30.7136C28.49 29.7802 28.0434 28.409 28.2922 27.0728C28.5398 25.7444 28.6658 24.3822 28.6658 22.9998C28.6658 15.2607 24.6756 8.39931 18.6658 5.08067C12.6559 8.39931 8.66578 15.2607 8.66578 22.9998C8.66578 24.3822 8.79172 25.7444 9.03924 27.0728C9.28818 28.409 8.84154 29.7802 7.85338 30.7136L5.65368 32.791L7.61746 36.3914ZM18.6658 22.9998C16.4566 22.9998 14.6658 21.209 14.6658 18.9998C14.6658 16.7907 16.4566 14.9999 18.6658 14.9999C20.8748 14.9999 22.6658 16.7907 22.6658 18.9998C22.6658 21.209 20.8748 22.9998 18.6658 22.9998Z",
    fill: "url(#paint0_linear_25532_2029)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_25532_2029",
    x1: 0.91272,
    y1: 0.635986,
    x2: 23.6829,
    y2: 39.4009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0F62FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFD2BC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeploy);
export default __webpack_public_path__ + "static/media/deploy.7ee2d9ef26220f750dba9288a1033b08.svg";
export { ForwardRef as ReactComponent };